import { Link } from 'react-router-dom';

import LoginImage from '@/assets/images/LoginImage.svg';
import { Button } from '@/components/ui/button';

type SignupInvitationUnavailableProps = {
  loginHref?: string;
  forgotPasswordHref?: string;
};

export function SignupInvitationUnavailable({
  loginHref = '/login',
  forgotPasswordHref = '/forgot-password',
}: SignupInvitationUnavailableProps) {
  return (
    <div className="flex w-full flex-col items-center">
      <img src={LoginImage} alt="Culture Monitor" className="mb-6 w-44" />
      <div className="flex w-full flex-col rounded-xl border border-[#E5E5E5] bg-white py-6 shadow-sm sm:w-96">
        <h1 className="px-6 text-center text-base font-semibold leading-5 text-[#0A0A0A]">
          Este link de convite não está mais disponível
        </h1>
        <p className="mt-6 px-6 text-sm leading-5 text-[#0A0A0A]">
          Ele pode ter expirado ou já ter sido utilizado.
          <br />
          Se você já ativou sua conta, é só entrar com seu e-mail e senha. Caso contrário, entre em
          contato com o atendimento da sua conta na Live.
        </p>
        <div className="mt-6 flex flex-col gap-2 px-6">
          <Button asChild className="h-9 w-full">
            <Link to={loginHref}>Ir para login</Link>
          </Button>
          <Button asChild variant="ghost" className="h-9 w-full text-[#0A0A0A]">
            <Link to={forgotPasswordHref}>Esqueci minha senha</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
